<div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 0px; padding: 15px 15px 15px;">
    <div class="row">
      <div class="col-md-5 col-sm-5 col-xs-4" style="display: inline-block;">
          <h4 style="display: inline-block;font-size: 18px;">Import Ledger</h4>
      </div>
  
      <div class="col-md-7 col-sm-7 col-xs-8" style="display: inline-block;">
          <span>
              <i class="closeMdl zmdi zmdi-close" style="float: right; margin-left: 5px; top: -5px !important;" (click)="closeModal()"></i>
          </span>
  
          <div> 
              <a *ngIf="ladgersList.length == 0" class="btn btn-orange brdrRadius3" href="assets/ExcelFiles/Biziverse - Import Ledgers.xlsx" style="float: right; line-height: unset;cursor: pointer; position: relative;color: white;font-size: 14px;padding: 2px 10px; box-shadow: none;">
                  <i class="zmdi zmdi-download" style="margin-right: 7px;line-height: 23px;font-size: 14px;"></i>Download Template
              </a>
          </div>
  
          <span class="greenBadge"  *ngIf="ladgersList.length > 0" style="display: inline-block; padding: 5px 12px; position: relative; float: right; top: -2px;">
            {{ladgersList.length}} errors found
          </span>

          <!-- <span class="btn btn-yellow" (click)="backtoImportScreen()" style="float: right; line-height: revert;font-size: 13px;padding: 4px 10px;display: inline-block;margin-right: 7px;" *ngIf="itemList.length > 0">
              <i class="zmdi zmdi-arrow-left" style="margin-right: 7px;"></i>Back
          </span> -->
      </div>
    </div>
  </div>
  
  <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px;">
      <div class="darkBlueButton brdrRadius3" *ngIf="!error.showError" style="margin-bottom: 10px; width: 100%; border-radius: 25px; padding: 7px 12px;cursor: pointer;line-height: 20px;" (click)="ImportFile.click()">
          <input type="file" id="input" (change)="onFileChange($event)" style="display: none;" #ImportFile/>
          <i class="fa fa-arrow-up"></i>
          <span style="margin-left: 10px; font-size: 14px;">Import Ledgers from Excel</span>
      </div>
  </div>
  <div style="padding-bottom: 7px;" *ngIf="!error.showError">
  </div>
  
  <!--Import Items Table-->
  <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="error.showError">
    <div class="row" style="margin: 0px;">
        <!-- WebView -->
        <div class="col-md-12" style="padding: 0px;">
            <div style="background-color: #fff; max-height: 280px; overflow-y: auto" *ngIf="data.length > 0">
                <table class="table table-bordered" style="margin-bottom: 0px;">
                    <thead>
                        <tr>
                            <th style="width: 1%; border-bottom: 0px;">No.</th>
                            <th style="width: 10%; border-bottom: 0px;">Ledger Name</th>
                            <th style="width: 20%; border-bottom: 0px;">Error</th>
                        </tr>
                    </thead>
                    <tbody>
                  
                        <tr *ngFor="let i of ladgersList" style="font-size: 12px;">
                            <td style="text-align: right;">{{i.srNo}}</td>
                            <td>{{i.ledgerName}}</td>
                            <td class="redText">
                               {{i.msg}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-top: 10px;" *ngIf="(error.showError && error.apiResponse == false && ladgersList.length == data.length) || (error.apiResponse == true)">
  
            </div>
            <div style="margin-top: 10px;" *ngIf="error.showError && error.apiResponse == false">
                <label style="font-weight: 500; cursor: pointer; font-size: 13px !important; line-height: 3;">
                    <input type="checkbox" [(ngModel)]="error.removeError" style="vertical-align: middle; margin-right: 3px; color: #dee2e6;"/> Ignore Errors
                </label>
                <span class="btn btn-green brdrRadius3" *ngIf="error.removeError" (click)="saveBulkItems();"
                  style="margin-left: 7px; padding: 3px 8px; border-radius: 25px;line-height: inherit;font-size: 13px;">
                    <i class="fa fa-check" style="padding-right: 7px;"></i>Save
                </span>
            </div>  
        </div>
    </div>
  </div>
